import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import { useMemo } from "react";

import { List } from "@/components/list/List";

import { DataTableSettingsContextProvider } from "@/components/data-table/DataTableSettingsContext";
import { DataTableSettings } from "@/types/dataTableSettings";
import { ReadAuditLog } from "@/types/auditLog";

export const AuditLogsDirectoryContent = () => {
  const settings = useDataTableSettings<ReadAuditLog>();
  const tableSettings = useMemo<DataTableSettings<ReadAuditLog>>(
    () => ({ ...settings }),
    [settings],
  );

  return (
    <DataTableSettingsContextProvider value={tableSettings}>
      <List.Content>
        <List.Status className="py-3 px-2" />
      </List.Content>
    </DataTableSettingsContextProvider>
  );
};
